(function($){
  var testimonialsSlider = {
    init: function(){
      if ($('.testimonials-slider').length){
        testimonialsSlider.initTestimonialsSlider();
      }
    },
    initTestimonialsSlider: function(){

      $('.testimonials-slider').flickity({
        prevNextButtons: false,
        autoPlay: 3000,
        wrapAround: true,
        pageDots: false,
        cellAlign: 'left',
      });

      $('.testimonials__btns .btn-slider.m--prev').on('click', function(){
        $('.testimonials-slider').flickity('previous');
      });
      $('.testimonials__btns .btn-slider.m--next').on('click', function(){
        $('.testimonials-slider').flickity('next');
      });
    }
  };
  $(document).ready(testimonialsSlider.init);
})(jQuery);
